import { CustomTheme } from 'themes/types'

import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles((theme: CustomTheme) => ({
    box: {
        [theme.breakpoints.down('lg')]: {
            flexDirection: 'column',

            '& .dateContainer > div': {
                flexDirection: 'column',
            },
        },
    },
    dateRangeField: {
        width: '100%',
        '& + div': {
            marginLeft: 20,

            [theme.breakpoints.down('lg')]: {
                margin: '20px 0 0',
            },
        },
    },
    selectInputs: {
        minWidth: 210,

        [theme.breakpoints.down('lg')]: {
            marginTop: 20,
            width: '100%',

            '&:last-child': {
                marginRight: 0,
            },

            '& > div': {
                marginRight: 0,
            },
        },
    },
    selectStatus: {
        [theme.breakpoints.down('lg')]: {
            marginTop: '20px !important',
            marginBottom: '20px !important',
        },
    },
    filterButton: {
        [theme.breakpoints.down('lg')]: {
            width: '100% !important',
        },
        [theme.breakpoints.down('md')]: {
            marginTop: '0 !important',
        },
    },
}))
